export default "__VITE_ASSET__DuucnmkU__"